import React from 'react'
import { Field as FieldConf, getFieldLabel } from 'src/config'
import * as types from '../../../types'
import { Switch, FormControlLabel } from '@mui/material'

const BooleanField: React.FC<{
    field: FieldConf,
    value?: types.SimpleValue,
    onChange: (value: types.Value) => void,
    disabled?: boolean
}> = ({
    field,
    value,
    onChange,
    disabled = false
}) => {
        const { name, label, description } = field;

        return (
            <FormControlLabel
                control={
                    <Switch
                        checked={value === true}
                        onChange={(e) => onChange(e.target.checked)}
                        disabled={disabled}
                    />
                }
                label={getFieldLabel(field)}
                about={description}
            />
        )
    }

export default BooleanField;